import { isFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';

export const webviewBuyFrame: boolean = IS_WEBVIEW && isFeature('webview-buy-frame');
export const webviewBuyFrameEnablePayment: boolean = IS_WEBVIEW && isFeature('webview-buy-frame-enable-payment');
